import { REFERENCE_ACTIVITY_PRESET_MONTHS } from './referenceOfferLogic';

export const ACTIVITY_PRESET_MONTHS = REFERENCE_ACTIVITY_PRESET_MONTHS;
export const ACTIVITY_FILTER_ERROR_MESSAGES = Object.freeze({
  missingRange: 'Informe data inicial e final válidas para aplicar o período.',
  endBeforeStart: 'Data final não pode ser anterior à data inicial',
  endAfterToday: 'Data final não pode ser posterior à data atual',
});

const ISO_DATE_PATTERN = /^\d{4}-\d{2}-\d{2}$/;

export const isIsoDate = value => {
  if (!ISO_DATE_PATTERN.test(String(value || ''))) return false;
  const date = new Date(`${value}T00:00:00Z`);
  return !Number.isNaN(date.getTime());
};

export const toIsoDate = date => {
  const normalizedDate = date instanceof Date ? date : new Date(date);
  if (Number.isNaN(normalizedDate.getTime())) return '';
  return normalizedDate.toISOString().slice(0, 10);
};

export const todayIsoDate = (now = new Date()) => toIsoDate(now);

export const monthsAgoIsoDate = (months, now = new Date()) => {
  const date = new Date(now);
  date.setMonth(date.getMonth() - Number(months || 0));
  return toIsoDate(date);
};

export const normalizeActivityMonths = value => {
  const months = Number(value);
  return ACTIVITY_PRESET_MONTHS.includes(months) ? String(months) : '';
};

export const normalizeActivityFilter = (filter = {}) => {
  const months = normalizeActivityMonths(filter.months);
  if (months) {
    return { months, startDate: '', endDate: '' };
  }

  const startDate = isIsoDate(filter.startDate) ? filter.startDate : '';
  const endDate = isIsoDate(filter.endDate) ? filter.endDate : '';
  if (!startDate || !endDate || endDate < startDate) {
    return { months: '', startDate: '', endDate: '' };
  }

  return { months: '', startDate, endDate };
};

export const activityFilterValidationError = (
  filter = {},
  now = new Date()
) => {
  const months = normalizeActivityMonths(filter.months);
  if (months) return '';

  const startDate = String(filter.startDate || '');
  const endDate = String(filter.endDate || '');
  if (!startDate && !endDate) return '';
  if (!isIsoDate(startDate) || !isIsoDate(endDate)) {
    return ACTIVITY_FILTER_ERROR_MESSAGES.missingRange;
  }
  if (endDate < startDate) {
    return ACTIVITY_FILTER_ERROR_MESSAGES.endBeforeStart;
  }
  if (endDate > todayIsoDate(now)) {
    return ACTIVITY_FILTER_ERROR_MESSAGES.endAfterToday;
  }
  return '';
};

export const activityRangeForFilter = (filter = {}, now = new Date()) => {
  const normalized = normalizeActivityFilter(filter);
  if (normalized.months) {
    return {
      submitted_from: monthsAgoIsoDate(normalized.months, now),
      submitted_to: todayIsoDate(now),
    };
  }

  if (normalized.startDate && normalized.endDate) {
    return {
      submitted_from: normalized.startDate,
      submitted_to: normalized.endDate,
    };
  }

  return {};
};

const formatDateLabel = value => {
  if (!isIsoDate(value)) return '';
  const [year, month, day] = value.split('-');
  return `${day}/${month}/${year}`;
};

export const activityFilterLabel = filter => {
  const normalized = normalizeActivityFilter(filter);
  if (normalized.months) {
    return normalized.months === '1'
      ? 'Último mês'
      : `Últimos ${normalized.months} meses`;
  }

  if (normalized.startDate && normalized.endDate) {
    return `${formatDateLabel(normalized.startDate)} à ${formatDateLabel(
      normalized.endDate
    )}`;
  }

  return '';
};
